(function () {
  const THRESHOLD = 100000; // ₹1000 = 100000 paise
  const GIFT_PROPERTY = '_free_gift';
 
  function init() {
    const section = document.getElementById('free-gift-section');
    if (!section) return;
    let isProcessing = false;
 
    async function fetchCart() {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    }
 
    function getGiftLineItems(cart) {
      return cart.items.filter(item => item.properties && item.properties[GIFT_PROPERTY] === 'true');
    }
 
    function getNonGiftSubtotal(cart) {
      return cart.items
        .filter(item => !(item.properties && item.properties[GIFT_PROPERTY] === 'true'))
        .reduce((sum, item) => sum + item.final_line_price, 0);
    }
 
    function updateUI(cart) {
      const subtotal = getNonGiftSubtotal(cart);
      const giftItems = getGiftLineItems(cart);
      const existingGift = giftItems[0];
 
      if (subtotal >= THRESHOLD) {
        section.style.display = '';
      } else {
        section.style.display = 'none';
      }
 
      const cards = section.querySelectorAll('.free-gift-card');
      cards.forEach(card => {
        const variantId = card.dataset.variantId;
        const btn = card.querySelector('.free-gift-btn');
        const msg = card.querySelector('.free-gift-disabled-msg');
 
        if (existingGift) {
          const isThisOne = String(existingGift.variant_id) === String(variantId);
          card.classList.toggle('is-selected', isThisOne);
          card.classList.toggle('is-disabled', !isThisOne);
          if (isThisOne) {
            btn.textContent = 'Remove Gift';
            btn.dataset.action = 'remove';
            btn.dataset.lineKey = existingGift.key;
            btn.disabled = false;
            msg.style.display = 'none';
          } else {
            msg.style.display = 'block';
          }
        } else {
          card.classList.remove('is-selected', 'is-disabled');
          btn.textContent = 'Add to Cart';
          btn.dataset.action = 'add';
          btn.dataset.lineKey = '';
          btn.disabled = false;
          msg.style.display = 'none';
        }
      });
 
      return { subtotal, existingGift };
    }
 
    // Passive re-check only — used for quantity changes / item removal elsewhere
    // on the cart page. Reloads automatically if the gift had to be auto-removed
    // because the subtotal dropped below the threshold.
    async function refresh() {
      const cart = await fetchCart();
      const { subtotal, existingGift } = updateUI(cart);
 
      if (subtotal < THRESHOLD && existingGift) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: existingGift.key, quantity: 0 })
        });
        // Subtotal fell below threshold -> gift auto-removed -> reload to reflect it
        location.reload();
      }
    }
 
    section.addEventListener('click', async (e) => {
      const btn = e.target.closest('.free-gift-btn');
      if (!btn || isProcessing) return;
      isProcessing = true;
      btn.disabled = true;
 
      try {
        if (btn.dataset.action === 'remove') {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: btn.dataset.lineKey, quantity: 0 })
          });
 
          // Gift removed -> reload immediately so cart totals + gift section refresh
          location.reload();
          return;
        } else {
          // re-check eligibility right before adding
          const cart = await fetchCart();
          const subtotal = getNonGiftSubtotal(cart);
          if (subtotal < THRESHOLD) {
            alert('Add more items worth ₹1000 to get a free gift.');
            isProcessing = false;
            btn.disabled = false;
            return;
          }
          if (getGiftLineItems(cart).length > 0) {
            alert('You already selected a free gift.');
            isProcessing = false;
            btn.disabled = false;
            return;
          }
 
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: btn.dataset.variantId, quantity: 1, properties: { [GIFT_PROPERTY]: 'true' } }]
            })
          });
 
          if (!addRes.ok) {
            const err = await addRes.json();
            console.error('Add gift failed', err);
            alert('Could not add gift. Please try again.');
            isProcessing = false;
            btn.disabled = false;
            return;
          }
 
          // Gift added successfully -> auto refresh the cart page immediately
          location.reload();
          return;
        }
      } finally {
        isProcessing = false;
      }
    });
 
    // Listen for quantity/remove changes from theme's own cart form
    document.addEventListener('cart:refresh', refresh);
 
    // Hook into theme's native cart update events (Dawn fires this)
    document.addEventListener('change', (e) => {
      if (e.target.closest('cart-items') || e.target.name === 'updates[]') {
        setTimeout(refresh, 800); // wait for theme's own AJAX update to finish
      }
    });
 
    // Also catch remove-item button clicks
    document.addEventListener('click', (e) => {
      if (e.target.closest('cart-remove-button')) {
        setTimeout(refresh, 800);
      }
    });
 
    refresh(); // initial check on page load
  }
 
  document.addEventListener('DOMContentLoaded', init);
})();
